import { useRef, useCallback } from "react";

export const useScrollPreservation = () => {
  const scrollPositionsRef = useRef(new Map());

  const saveScrollPosition = useCallback((containerId) => {
    const container =
      document.querySelector(containerId) ||
      document.querySelector(`[data-container="${containerId}"]`) ||
      document.querySelector(`.${containerId}`);
    if (container) {
      scrollPositionsRef.current.set(containerId, container.scrollTop);
    }
  }, []);

  const restoreScrollPosition = useCallback((containerId) => {
    const scrollTop = scrollPositionsRef.current.get(containerId);
    if (scrollTop !== undefined) {
      setTimeout(() => {
        const container =
          document.querySelector(containerId) ||
          document.querySelector(`[data-container="${containerId}"]`) ||
          document.querySelector(`.${containerId}`);
        if (container) {
          container.scrollTop = scrollTop;
        }
      }, 0);
    }
  }, []);

  const saveAllKanbanScrolls = useCallback(() => {
    const columns = document.querySelectorAll(".kanban-column-content");
    columns.forEach((column, index) => {
      const columnId = `kanban-column-${index}`;
      scrollPositionsRef.current.set(columnId, column.scrollTop);
    });
  }, []);

  const restoreAllKanbanScrolls = useCallback(() => {
    const columns = document.querySelectorAll(".kanban-column-content");
    columns.forEach((column, index) => {
      const columnId = `kanban-column-${index}`;
      const scrollTop = scrollPositionsRef.current.get(columnId);
      if (scrollTop !== undefined) {
        setTimeout(() => {
          column.scrollTop = scrollTop;
        }, 0);
      }
    });
  }, []);

  return {
    saveScrollPosition,
    restoreScrollPosition,
    saveAllKanbanScrolls,
    restoreAllKanbanScrolls,
  };
};
